import { Col, Row, Table, Spin } from "antd";
import { Grid } from "antd";
import { MyButton, MyText } from "../../../common";
import { ShareAltOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { COOKIE_KEY, fetchDiaryTableAction, RootState, selectStore } from "../../../../utils";
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import {Cookies} from "react-cookie";
import { ConsultationFormModal } from "../../../popups/ConsulationPopup/ConsultationPopup";

interface TableBlockProps {
  weekId: number | null;
  childId: number | null;
}

const ACTIVITY_LABELS: Record<number, string> = {
  1: 'Низкая',
  2: 'Средняя',
  3: 'Высокая',
};

export const TableBlock: React.FC<TableBlockProps> = ({ weekId, childId }) => {
    const { t } = useTranslation("common");
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const dispatch = useDispatch();
    const embeddedNavigate = useEmbeddedNavigate();
    const cookies = new Cookies()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [canSelectSpecialist, setCanSelectSpecialist] = useState(false);
    const diaryTable = useSelector((state: any) => state.materials?.diaryTable ?? { data: null, loading: false });
    const { profile: { userData: userDataState, specialistsData: specialistsState}}: RootState = useSelector(selectStore);
    let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
    const [selectedItem, setSelectedItem] = useState(null);
    const specialists = Array.isArray(specialistsState?.data)
        ? specialistsState.data
        : [];
    const weekName = diaryTable.data?.week?.name ?? null;   
    const showModal = () => {
        console.log("showModal вызван");
        setIsModalVisible(true);
        setCanSelectSpecialist(true);
    };
    const handleOk = () => setIsModalVisible(false);
    const handleCancel = () => {
        setIsModalVisible(false);
        setCanSelectSpecialist(false);
    };

    useEffect(() => {
        if (weekId && childId) {
            dispatch(fetchDiaryTableAction({ weekId, childId }));
        }
    }, [weekId, childId]);

    const rows = diaryTable.data?.rows ?? [];
    const childrenList = useSelector(
    (state: any) => state.materials?.childrens?.data?.children ?? []
    );

    const selectedChild = childrenList.find((child: any) => child.id === childId) ?? null;

    const childInfo = selectedChild
    ? {
        name: selectedChild.full_name,
        birth_date: selectedChild.birth_date,
        age: selectedChild.age_formatted,
        gender: selectedChild.gender_text,
        }
    : null;

    const diagnosticResults = useSelector(
    (state: any) => state.materials?.diagnosticResults?.data ?? {}
    );

    const diagnosticResult = childId ? (diagnosticResults[childId] ?? null) : null;
    const dataSource = rows.map((row: any, index: number) => ({
        key: String(row.day?.id ?? index),
        day: row.day?.name ?? '',
        words: row.diary?.words_sounds ?? '–',
        gestures: row.diary?.gestures_actions ?? '–',
        understood: row.diary
            ? (row.diary.understood_instruction ? 'Да' : 'Нет')
            : '–',
        activity: row.diary
            ? (ACTIVITY_LABELS[row.diary.activity_level] ?? '–')
            : '–',
        comment: row.diary?.parent_comment ?? '–',
    }));

    const columns = [
        {
            title: 'День',
            dataIndex: 'day',
            key: 'day',
            width: 60,
            render: (val: string) => <span style={{ fontWeight: 700, fontSize: 15 }}>{val}</span>,
        },
        {
            title: 'Какие слова/звуки повторил ребёнок?',
            dataIndex: 'words',
            key: 'words',
        },
        {
            title: 'Какие жесты/действия показал?',
            dataIndex: 'gestures',
            key: 'gestures',
        },
        {
            title: 'Понял ли инструкции?',
            dataIndex: 'understood',
            key: 'understood',
            width: 130,
        },
        {
            title: 'Активность ребёнка',
            dataIndex: 'activity',
            key: 'activity',
            width: 130,
        },
        {
            title: 'Комментарии родителя (какие новые слова или звуки появились)',
            dataIndex: 'comment',
            key: 'comment',
        },
    ];

    return (
        <Col span={24}>
            <Row style={{
                background: '#FFFFFF',
                border: '1px solid #E5E9F2',
                borderRadius: 24,
                overflow: 'hidden',
            }}>
                <Col span={24} style={{ padding: 24 }}>
                    <Row align="middle" justify="space-between" wrap={false}>
                        <Col>
                            <MyText
                                color="#130F26"
                                size={28}
                                weight={800}
                                style={{ fontFamily: 'Nunito', display: 'block' }}
                            >
                                Таблица наблюдений
                            </MyText>
                        </Col>
                        <Col>
                            <Row gutter={12} wrap={false}>
                                {/* <Col>
                                    <MyButton
                                    color="orange"
                                    type="primary"
                                        icon={<ShareAltOutlined />}
                                    >
                                        Поделиться
                                    </MyButton>
                                </Col> */}
                                <Col>
                                    <MyButton
                                        color="blue"
                                        type="primary"
                                        icon={<QuestionCircleOutlined />}
                                        onClick={() => {
                                        if (token) {
                                        if (userDataState?.data?.first_name && userDataState?.data?.last_name && userDataState?.data?.region_id) {
                                            showModal();
                                        } else {
                                            embeddedNavigate('/register/confirm');
                                        }
                                        } else {
                                        embeddedNavigate('/auth');
                                        }
                                    }}
                                    >
                                        Задать вопрос специалисту
                                    </MyButton>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col span={24}>
                    <Spin spinning={diaryTable.loading}>
                        <Table
                            dataSource={dataSource}
                            columns={columns}
                            pagination={false}
                            bordered
                            components={{
                                header: {
                                    cell: (props: any) => (
                                        <th
                                            {...props}
                                            style={{
                                                ...props.style,
                                                background: '#F4F5F7',
                                                fontWeight: 700,
                                                fontSize: 14,
                                                color: '#130F26',
                                                padding: '12px 16px',
                                            }}
                                        />
                                    ),
                                },
                                body: {
                                    cell: (props: any) => (
                                        <td
                                            {...props}
                                            style={{
                                                ...props.style,
                                                fontSize: 15,
                                                color: '#374151',
                                                padding: '14px 16px',
                                                verticalAlign: 'middle',
                                                background: '#fff',
                                            }}
                                        />
                                    ),
                                },
                            }}
                            style={{ borderRadius: 0, border: 'none' }}
                        />
                    </Spin>
                </Col>
            </Row>
            <ConsultationFormModal
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                specialists={specialists}
                selectedItem={selectedItem}
                canSelectSpecialist={canSelectSpecialist}
                childInfo={childInfo}
                diagnosticResult={diagnosticResult}
                diaryWeekName={weekName}
                diaryTable={dataSource}
                showAutoInfoNote={true}
            />
            
        </Col>
    );
};